<template>
    <div>
<!--        <h4>{{ title }}</h4>-->
      <div v-if="Object.keys(emailLogs).length > 0">
        <div v-for="(group, date) in emailLogs" :key="date">
          <div class="row mobile-p-bottom-0">
            <div class="col-md-offset-3 col-md-6 created-date">
              {{ date }}
            </div>
          </div>
          <div></div>
          <email-log-row v-for="(log, index) in group" :log="log" :key="index"></email-log-row>
        </div>

      </div>

    </div>
</template>

<script>
import moment from 'moment-timezone';
import EmailLogRow from "./EmailLogRow.vue";
export default {
    name: "EmailLogTable",
  components: {EmailLogRow},
    props: {
        emailLogs: {
            type: Object,
            required: true
        },
        title: {
            type: String,
            required: true
        }
    }
};
</script>
<style scoped>
.created-date{
    font-family: Roboto;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: center;
    color: rgb(98, 112, 124);
}
@media (max-width: 991px) {
  .mobile-p-bottom-0 {
    padding-bottom: 0px;
  }
}
</style>
